import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext"; // Importe o contexto
import axios from "axios";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';
import PodcastsIcon from '@mui/icons-material/Podcasts';
import ScienceIcon from '@mui/icons-material/Science';
import backgroundImg from "../../assets/ImgFundo/map.jpg";

const PaineldeControleGeral = () => {
  const navigate = useNavigate();
  const { isAuthenticated, login } = useAuth(); // Use o contexto
  const [formData, setFormData] = useState({ username: "", password: "" });
  const [errorMessage, setErrorMessage] = useState("");
  const apiUrl = process.env.REACT_APP_API_URL;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    console.log("Form data atualizado:", { ...formData, [name]: value }); // LOG
  };

  const handleLogin = async (e) => {
    e.preventDefault();

    console.log("Tentando autenticar com:", formData); // LOG

    try {
      const response = await axios.post(`${apiUrl}/auth/login`, {
        username: formData.username,
        password: formData.password,
      });

      console.log("Resposta do servidor:", response.data); // LOG

      if (response.data && response.data.token) {
        login(); // Atualize o estado global de autenticação
        localStorage.setItem("token", response.data.token);
        setErrorMessage("");
        console.log("Autenticado com sucesso! Navegando para PainelDeControle."); // LOG
        navigate("/PainelDeControle");
      } else {
        setErrorMessage("Nome de usuário ou senha inválidos.");
        console.log("Erro de autenticação: Nome de usuário ou senha inválidos."); // LOG
      }
    } catch (error) {
      console.error("Erro na autenticação:", error);
      setErrorMessage("Erro ao autenticar. Tente novamente.");
    }
  };

  const navigateTo = (route) => {
    console.log("Tentando navegar para:", route); // LOG
    navigate(`/${route}`);
  };

  return (
    <div style={{
      backgroundImage: `url(${backgroundImg})`,
      backgroundSize: "cover",
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat",
      minHeight: "100vh",
      padding: "24px",
      textAlign: "center",
    }}>


      <hr style={{ margin: '40px 0', borderTop: '1px solid #ddd' }} />
      <hr style={{ margin: '40px 0', borderTop: '1px solid #ddd' }} />
      <Typography
        variant="h2"
        align="center"
        gutterBottom
        style={{
          fontFamily: "'Lato', serif",
          color: "white",
          borderBottom: "4px solidrgb(8, 8, 7)",
          paddingBottom: "10px",
          textTransform: "uppercase",
          borderBottom: "4px solid #d4af37",
          animation: "glow 2s infinite alternate",
          marginTop: "7%"  // Aqui é onde você define o espaço superior
        }}
      >
        Painel de Controle
      </Typography>

      {!isAuthenticated ? (
        <form onSubmit={handleLogin} noValidate style={{ maxWidth: "400px", margin: "0 auto", padding: "24px", backgroundColor: "#fff", borderRadius: "8px", boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)" }}>
          <TextField
            fullWidth
            label="Nome de Usuário"
            variant="outlined"
            name="username"
            value={formData.username}
            onChange={handleChange}
            required
            autoComplete="username"
            margin="normal"
            InputProps={{ style: { borderRadius: "8px" } }}
          />
          <TextField
            fullWidth
            label="Senha"
            type="password"
            variant="outlined"
            name="password"
            value={formData.password}
            onChange={handleChange}
            required
            autoComplete="current-password"
            margin="normal"
            InputProps={{ style: { borderRadius: "8px" } }}
          />
          {errorMessage && (
            <Typography color="error" variant="body2" gutterBottom style={{ marginTop: "8px" }}>
              {errorMessage}
            </Typography>
          )}
          <Button
            fullWidth
            variant="contained"
            color="primary"
            type="submit"
            size="large"
            style={{ marginTop: "24px", borderRadius: "8px", padding: "12px", fontWeight: "bold", textTransform: "none" }}
          >
            Entrar
          </Button>
        </form>
      ) : (
        <Grid container spacing={4} justifyContent="center" style={{ padding: "24px" }}>
        <Grid item xs={12} sm={6}>
          <DashboardCard
            title="Criação de Novo Verbete"
            color="green"
            description="Criação dos verbetes do sistema."
            onClick={() => navigateTo("PainelDeControle/DashBoardVerbetes")}
            icon={<LibraryBooksIcon style={{ fontSize: "48px", color: "#1976d2" }} />}
          />
        </Grid>
      
        <Grid item xs={12} sm={6}>
          <DashboardCard
            title="Editor de Verbetes"
            color="red"
            description="Gerencie (Exclua e edite) os verbetes"
            onClick={() => navigateTo("PainelDeControle/Editores/ListagemEdicoesVerbetes")}
            icon={<ScienceIcon style={{ fontSize: "48px", color: "#1976d2" }} />}
            sx={{
              backgroundColor: '#f5bf5f5', 
              padding: 2,
              borderRadius: 2,
            }}
          />
        </Grid>
      
        <Grid item xs={12} sm={6}>
          <DashboardCard
            title="Criar Novo Podcast - Divulgação Científica"
            description="Criação de Podcast."
            color="green"
            onClick={() => navigateTo("PainelDeControle/DashBoardPodcast")}
            icon={<PodcastsIcon style={{ fontSize: "48px", color: "#1976d2" }} />}
          />
        </Grid>
      
        <Grid item xs={12} sm={6}>
          <DashboardCard
            title="Editor Podcast - Divulgação Científica"
            color="red"
            description="Gerencie (Exclua e Edite) os Podcasts"
            onClick={() => navigateTo("PainelDeControle/Editores/ListagemEdicoesPodcast")}
            icon={<ScienceIcon style={{ fontSize: "48px", color: "#1976d2" }} />}
            sx={{
              backgroundColor: '#f5bf5f5',
              padding: 2,
              borderRadius: 2,
            }}
          />
        </Grid>
      
        <Grid item xs={12} sm={6}>
          <DashboardCard
            title="Criar Novo Artigo - Divulgação Científica"
            description="Criar Novas Matérias."
            color="green"
            onClick={() => navigateTo("PainelDeControle/DashBoardArtigos")}
            icon={<ScienceIcon style={{ fontSize: "48px", color: "#1976d2" }} />}
          />
        </Grid>
      
        <Grid item xs={12} sm={6}>
          <DashboardCard
            title="Editor de Artigo - Divulgação Científica"
            color="red"
            description="Gerencie (Exclua e Edite) as Matérias"
            onClick={() => navigateTo("PainelDeControle/Editores/ListagemEdicoesArtigo")}
            icon={<ScienceIcon style={{ fontSize: "48px", color: "#1976d2" }} />}
            sx={{
              backgroundColor: '#f5bf5f5',
              padding: 2,
              borderRadius: 2,
            }}
          />
        </Grid>
      
        <Grid item xs={12} sm={6}>
          <DashboardCard
            title="Contagem de Visualizações - Divulgação Científica"
              color="blue"
            description="Gerencie a Contagem de Visualizações"
            onClick={() => navigateTo("PainelDeControle/ContagemVisualizacoes")}
            icon={<ScienceIcon style={{ fontSize: "48px", color: "#1976d2" }} />}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <DashboardCard
            title="Contagem de Visualizações - Documentos e Verbetes"
            color="blue"
            description="Gerencie a Contagem de Visualizações"
            onClick={() => navigateTo("PainelDeControle/ContagemDocumentos")}
            icon={<ScienceIcon style={{ fontSize: "48px", color: "#1976d2" }} />}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <DashboardCard
            title="Criação de Novo Autor"
            color="green"
            description="Cadastre novos autores."
            onClick={() => navigateTo("PainelDeControle/DashBoardAutores")}
            icon={<LibraryBooksIcon style={{ fontSize: "48px", color: "#1976d2" }} />}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <DashboardCard
            title="Editar Autores"
            color="red"
            description="Gerencie (edite) autores já cadastrados."
            onClick={() => navigateTo("PainelDeControle/DashBoardAutores")}
            icon={<LibraryBooksIcon style={{ fontSize: "48px", color: "#1976d2" }} />}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <DashboardCard
            title="Criar Documento Avulso"
            color="blue"
            description="Cadastre documentos que nao possuem verbete."
            onClick={() => navigateTo("PainelDeControle/DashBoardDocumentos")}
            icon={<LibraryBooksIcon style={{ fontSize: "48px", color: "#1976d2" }} />}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <DashboardCard
            title="Editar Documentos Avulsos"
            color="red"
            description="Gerencie (edite e exclua) documentos avulsos."
            onClick={() => navigateTo("PainelDeControle/Editores/ListagemEdicoesDocumentos")}
            icon={<LibraryBooksIcon style={{ fontSize: "48px", color: "#1976d2" }} />}
          />
        </Grid>
      </Grid>
      
      )}
    </div>
  );
};


const DashboardCard = ({ title, description, onClick, color }) => (
  <Card
    style={{
      padding: "16px",
      textAlign: "left",
      borderRadius: "12px",
      boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
      transition: "transform 0.3s ease, box-shadow 0.3s ease",
      backgroundColor: 
      color === "green" ? "#4CAF50" : // Verde
      color === "red" ? "#F44336" :   // Vermelho
      color === "blue" ? "#2196F3" :  // Azul (cor do Material-UI)
      "#f5f5f5", // Cor padrão (cinza claro)   
       }}
    onMouseEnter={(e) => {
      e.currentTarget.style.transform = "scale(1.03)";
      e.currentTarget.style.boxShadow = "0px 6px 15px rgba(0, 0, 0, 0.2)";
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.transform = "scale(1)";
      e.currentTarget.style.boxShadow = "0px 4px 10px rgba(0, 0, 0, 0.1)";
    }}
  >
    <CardContent>
    <Typography
  variant="h5"
  align="center"
  gutterBottom
  style={{
    fontFamily: "'Lato', serif",
    color: "white",
    borderBottom: "4px solid rgb(250, 249, 246)", // Borda inferior ajustada
    paddingBottom: "10px",
    textTransform: "uppercase",
    animation: "glow 2s infinite alternate",
    marginTop: "7%", // Espaço superior ajustado
    textShadow: "2px 2px 4px rgba(0, 0, 0, 0.5)", // Sombra adicionada
  }}
>
        {title}
      </Typography>
      <Typography
        variant="body2"
        style={{ color:  "white",  marginBottom: "16px" }} // Texto neutro
      >
        {description}
      </Typography>
      <Button
        variant="contained"
        color="primary"
        onClick={onClick}
        fullWidth
        style={{
          backgroundColor: "#1976d2",
          color: "#fff",
          padding: "10px",
          borderRadius: "8px",
          fontWeight: "bold",
          textTransform: "none",
        }}
      >
        Acessar
      </Button>
    </CardContent>
  </Card>
);






export default PaineldeControleGeral;
